<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false" >
        <template #title>
          <strong>提现</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.replace('/withdraw')"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="main">
      <van-cell is-link @click="show = true">{{ bankInfo.bank_name }}</van-cell>
      <van-cell>
        <div class="flex align-center">
          <span class="fs-36 fw-700">￥</span>
          <van-field v-model="money" type="number" :placeholder="`可转出到卡${userAccountInfo.balance}元`" :border="false" clearable />
          <span class="txt-nowrap" @click="money = userAccountInfo.balance">全部</span>
        </div>
      </van-cell>
      <p v-show="money" class="withdraw-tips">申请提现金额 <strong class="color-FC3159">{{ money }}</strong>元，实际到账为税后金额 <strong class="color-FC3159">{{ (money * (1 - userAccountInfo.rate)).toFixed(2) }}</strong> 元。</p>
      <div class="btn-wrapper">
        <van-button class="br-10" color="#fc3159" block @click="withdraw">确认提现</van-button>
      </div>
    </div>
    <!-- 选择银行卡 -->
    <van-action-sheet v-model="show" cancel-text="取消" close-on-click-action>
      <router-link tag="div" to="/withdraw/bind-card" class="row"><van-icon name="credit-pay" class="fs-28 mr-8" />更换银行卡</router-link>
    </van-action-sheet>
    <!-- 选择银行卡 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { withdraw, getBankInfo } from '@/api/common.js'
export default {
  name: 'WithdrawCard',
  data() {
    return {
      show: false, // 默认不显示银行卡列表
      money: '',
      bankInfo: {}
    }
  },
  computed: {
    ...mapState(['userAccountInfo'])
  },
  async created() {
    try {
      this.$store.commit('TOGGLE_LOADING', true)
      await this.getBankInfo()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
  },
  methods: {
    async withdraw() {
      if (!this.money || this.money < 100) {
        this.$toast.fail('提现金额最少不能低于100元人民币')
        return
      }
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        if (Number(this.money) > Number(this.userAccountInfo.balance)) {
          this.$toast.fail('当前输入值大于剩余余额,不可以提现!')
          return
        }
        const res = await withdraw({ put_money: this.money })
        if (res.code === 1) {
          await this.$store.dispatch('getUserInfo')
          this.money = ''
          this.$toast(res.msg)
        }
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    async getBankInfo() {
      const res = await getBankInfo({})
      this.bankInfo = res.data
      if (!this.bankInfo.bank_name || !this.bankInfo.account_no) {
        this.$router.push('/withdraw/bind-card')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main{
  margin-top: 25px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0 -6px 8px 0 #f3efef;
  overflow: hidden;
  .btn-wrapper{
    margin: 10px 56px;
  }
}
.row{
  display: flex;
  align-items: center;
  line-height: 35px;
  padding: 10px 16px;
  font-size: 16px;
  &:not(:last-child){
    border-bottom: 1px solid #e5e5e9;
  }
}
.withdraw-tips{
  font-size: 12px;
  color: #666;
  padding: 10px 15px;
}
</style>
